export default "assets/images/logo-667f417e.png";